import React, { FC, useEffect, useRef, useState } from "react";
import SignatureCanvas from 'react-signature-canvas';
import { useGuardianContext } from "../../../context/GuardianContext";
import { MediaApi } from "../../../api/MediaApi";
import { useParams } from "react-router-dom";


interface GuardianSignatureProps {
    isCurrentGuardianSinged: boolean
}

export const GuardianSignature: FC<GuardianSignatureProps> = ({ isCurrentGuardianSinged }) => {

    const { guardianId } = useParams();
    const { updateSignature, formSubmission } = useGuardianContext();
    const signatureRef = useRef<SignatureCanvas>(null);
    const containerRef = useRef(null);
    const [showPlaceholder, setShowPlaceholder] = useState(true);
    const [signatureImage, setSignatureImage] = useState(null);
    const [dimensions, setDimensions] = useState({ width: 0, height: 100 });
    const [isSigned, setIsSigned] = useState(true);

    const currentGuardian = formSubmission.guardians.find(g => g.id === guardianId);

    const saveSignature = () => {
    if (signatureRef.current && isSigned) {
        setSignatureImage(signatureRef.current.toDataURL());
        updateSignature(signatureRef.current.toDataURL());  
    }
  };

    const clearSignature = () => {
    if (signatureRef.current) {
            setShowPlaceholder(true);
            signatureRef.current.clear();
            updateSignature(undefined)
            setSignatureImage(null);
            setIsSigned(false);
        }
    };

    const restoreSignature = () => {
    if (signatureImage && signatureRef.current) {
      const canvas = signatureRef.current.getCanvas();
      const ctx = canvas.getContext('2d');
      const img = new Image();
      
      img.onload = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, dimensions.width, dimensions.height);
      };
      img.src = signatureImage;
    }
  };

    useEffect(() => {
        const updateSize = () => {
            if (containerRef.current) {
                const width = containerRef.current.offsetWidth;
                setDimensions({ width, height: 100 });
            }
        };

        updateSize();
        window.addEventListener('resize', updateSize);
        
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    const onBeginSign = () => {
        setIsSigned(true);
        setShowPlaceholder(false);
    }

    useEffect(() => {
    if (dimensions.width > 0) {
      const timer = setTimeout(() => {
        restoreSignature();
      }, 100);
        
        return () => clearTimeout(timer);
        }
    }, [dimensions]);

    return (
        <div id='guardian-signature' ref={containerRef} className="w-100">
            {!isCurrentGuardianSinged && <SignatureCanvas
                ref={signatureRef}
                onBegin={onBeginSign}
                onEnd={saveSignature}
                canvasProps={{ 
                    width: dimensions.width, 
                    height: dimensions.height, 
                    className: 'sigCanvas',
                    style: {
                        backgroundImage: showPlaceholder ? `url(${require('../../../images/signature-icon.svg')})` : 'none',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center 24px',
                        backgroundColor: '#F7F8FB',
                        border: '0.5px solid rgb(204, 214, 227)',
                        borderRadius: '4px'
                    } 
                }}
            />}
            {isCurrentGuardianSinged && (
                <div style={{
                        backgroundImage: currentGuardian ? `url(${MediaApi.imageWebThumbnail(currentGuardian.signatureMediaId)})` : 'none',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundColor: '#F7F8FB',
                        border: '0.5px solid rgb(204, 214, 227)',
                        borderRadius: '4px',
                        width: dimensions.width, 
                        height: dimensions.height, 
                    }}>
                    
                </div>
            )}
            {!isCurrentGuardianSinged && <button className="clear-btn mt-3" onClick={clearSignature}>Clear</button>}
        </div>
    )
}